import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showServerErrorMessage: false,
  pageError: { page: "", status: "" },
};

export const errorManagementSlice = createSlice({
  name: "ErrorManagement",
  initialState,
  reducers: {
    setShowServerErrorMessage: (state, action) => {
      if (action.payload >= 500) {
        state.showServerErrorMessage = true;
      }
    },
    setPageError: (state, action) => {
      state.pageError = action.payload;
    },
  },
});

export const { setShowServerErrorMessage, setPageError } =
  errorManagementSlice.actions;

export default errorManagementSlice.reducer;
